import React from 'react'
import MoveItem from "./MoveItem"
import "./moveList.css"

export default function MoveList({moves, localData}) {
  return (
    <div className="move-list">
        {
            localData.movesKnown.map((move, index) =>{
                return <MoveItem key={`move-item${index}`} move={moves[move]}></MoveItem>
            })
        }
    </div>
  )
}
